export const DEFAULT_LOCALE = 'fr'
export const SUPPORTED_LOCALES = ['fr', 'en']
export const LOCALE_STORAGE_KEY = 'workflowpro_locale'

export function isSupportedLocale(locale) {
  return SUPPORTED_LOCALES.includes(locale)
}

export function resolveLocale(locale) {
  return isSupportedLocale(locale) ? locale : DEFAULT_LOCALE
}

export function readStoredLocale(storage = globalThis.localStorage) {
  try {
    return resolveLocale(storage?.getItem(LOCALE_STORAGE_KEY))
  } catch {
    return DEFAULT_LOCALE
  }
}

export function persistLocale(locale, storage = globalThis.localStorage) {
  const resolvedLocale = resolveLocale(locale)

  try {
    storage?.setItem(LOCALE_STORAGE_KEY, resolvedLocale)
  } catch {
    // localStorage can be unavailable in private or restricted browser contexts.
  }

  return resolvedLocale
}

export function syncDocumentLanguage(locale, documentRef = globalThis.document) {
  const resolvedLocale = resolveLocale(locale)

  if (documentRef?.documentElement) {
    documentRef.documentElement.lang = resolvedLocale
  }

  return resolvedLocale
}

export function lookupTranslation(dictionary, key) {
  return key.split('.').reduce((value, part) => value?.[part], dictionary)
}

export function interpolate(template, params = {}) {
  return template.replace(/\{([a-zA-Z0-9_]+)\}/g, (match, name) => (
    Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match
  ))
}

export function translate(dictionary, fallbackDictionary, key, params = {}) {
  const value = lookupTranslation(dictionary, key) ?? lookupTranslation(fallbackDictionary, key)

  return typeof value === 'string' ? interpolate(value, params) : key
}
